import * as Types from './types';
import { Dispatch } from 'redux';
import {
  IAction,
  IActionMethods,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as PaymentRemindersService from '../../../services/api/payment_reminders';

class FetchPaymentRemindersList implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_PAYMENT_REMINDERS_LIST,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }

  onSuccess(data: any): IAction {
    return {
      type: Types.SET_PAYMENT_REMINDERS_LIST,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_PAYMENT_REMINDERS_LIST,
      status: StateStatus.Failed,
      data: KEEP_THE_SAME,
    };
  }

  action(payload: PaymentRemindersService.IPaymentRemindersListInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await PaymentRemindersService.fetchPaymentRemindersList(
          payload
        );
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('Fetch PaymentReminders Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

interface IPaymentRemindersToGenerate {
  onFinish?: (success: boolean) => void;
}
class PaymentRemindersToGenerate implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_PAYMENT_REMINDERS_TO_GENERATE,
      status: StateStatus.Pending,
      data: {},
    };
  }

  onSuccess(): IAction {
    return {
      type: Types.SET_PAYMENT_REMINDERS_TO_GENERATE,
      status: StateStatus.Success,
      data: {},
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_PAYMENT_REMINDERS_TO_GENERATE,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: IPaymentRemindersToGenerate): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        const { onFinish } = payload;
        await PaymentRemindersService.paymentRemindersToGenerate();
        dispatch(this.onSuccess());
        onFinish && onFinish(true);
      } catch (error: any) {
        const { onFinish } = payload;
        // console.log('PaymentRemindersToGenerate Error:', error.message);
        dispatch(this.onFailed());
        onFinish && onFinish(false);
      }
    };
  }
}

export default {
  fetchPaymentRemindersListListAction: (
    payload: PaymentRemindersService.IPaymentRemindersListInput
  ) => new FetchPaymentRemindersList().action(payload),
  paymentRemindersToGenerateAction: (payload: IPaymentRemindersToGenerate) =>
    new PaymentRemindersToGenerate().action(payload),
};
